<template>
  <div>
    <display-categories
      v-if="!isLoading && currentServiceArea"
      :current-service-area="currentServiceArea"
      :service-areas="standardCategories"
      :platform-category="platformCategory"
      :platform-category-name="platformCategoryName"
      @clickSARoute="clickSARoute"
    ></display-categories>

    <display-services :services="services" :platform-category="platformCategory" v-if="services"></display-services>
  </div>
</template>

<script>
import DisplayServices from "@/components/service-browser/DisplayServices.vue";
import DisplayCategories from "@/components/service-browser/DisplayCategories.vue";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "BrowseStandardService",
  props: {
    platformCategory: String,
    platformCategoryName: String,
    categoryId: String
  },
  components: {
    DisplayServices,
    DisplayCategories
  },
  data() {
    return {
      selectedServiceArea: undefined
    };
  },
  computed: {
    ...mapGetters(["standardCategories", "isLoading","platformCategories"]),
    services() {
      if (this.currentServiceArea) {
        return [this.currentServiceArea];
      }
      return undefined;
    },
    currentServiceArea() {
      if (this.selectedServiceArea) {
        return this.selectedServiceArea;
      } else if (this.standardCategories) {
        return this.standardCategories[0];
      } else {
        return null;
      }
    }
  },
  methods: {
    ...mapActions(["fetchStandardCategories"]),
    clickSARoute(sa) {
      this.selectedServiceArea = sa;
      this.$router.push(`/${this.platformCategory}/categories/${sa.id}`);
      let updateDocumentTitle = false
      this.trackBrowseActions(this.platformCategory, sa.name, updateDocumentTitle);
      document.title = "Autodesk One - " + this.platformCategories.find(category => category.alias === this.platformCategory).name + " Browse Actions"
    }
  },
  created() {
    this.fetchStandardCategories(this.platformCategory).then(() => {
      if (!this.categoryId) {
        this.clickSARoute(this.currentServiceArea);
        return;
      }

      let sa = this.standardCategories.find(
        item => item.id === this.categoryId
      );
      if (sa) {
        this.clickSARoute(sa);
      }
    });
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/service-browser/BrowseStandardService.vue